// Filter Products By Filters

export default (productList, filters, body) => {
  let filteredList = [...productList];
  for (const key in filters) {
    if (filters.code !== body.code || filters.hash !== body.hash) {
      return filteredList;
    }
    if (key === "sizes") {
      let sizeCheckList = filteredList;

      if (Number(filters.sizes.horizontal) > 0) {
        sizeCheckList = sizeCheckList.filter(
          (el) =>
            Number(filters.sizes.horizontal) -
              Number(filters.sizes.range || 0) <=
              Number(el.horizontal) &&
            Number(el.horizontal) <=
              Number(filters.sizes.horizontal) +
                Number(filters.sizes.range || 0)
        );
      }
      if (Number(filters.sizes.vertical) > 0) {
        sizeCheckList = sizeCheckList.filter(
          (el) =>
            Number(filters.sizes.vertical) - Number(filters.sizes.range || 0) <=
              Number(el.vertical) &&
            Number(el.vertical) <=
              Number(filters.sizes.vertical) + Number(filters.sizes.range || 0)
        );
      }
      if (Number(filters.sizes.height) > 0) {
        sizeCheckList = sizeCheckList.filter(
          (el) =>
            Number(filters.sizes.height) - Number(filters.sizes.range || 0) <=
              Number(el.height) &&
            Number(el.height) <=
              Number(filters.sizes.height) + Number(filters.sizes.range || 0)
        );
      }
      return sizeCheckList;
    }
  }
  return filteredList;
};
